// export this package's api
import Drawer from './Drawer';
export default Drawer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rmc-drawer/es/index.js
// module id = 328
// module chunks = 0